<app-windowlist [model]="this">
    <div class="row">
        <div class="col-lg-2 pr-lg-0" *ngIf="filterbox">
            <div class="d-none d-lg-block w-100 text-center text-primary">Filtri</div>
            <app-filtercontainer [title]="'Filtra per date'" >
                <app-filterdate [date_type]="100" [class]="'card p-1 mb-2'" [filter_date]="filter_date" (onSelect)="getItems()"></app-filterdate>
            </app-filtercontainer>
        </div>
        <div [class.col-lg-10]="filterbox" [class.col-lg-12]="!filterbox" >
            <div class="card elevation-0 border-0">
                <div class="p-0">
                    <div class="row" *ngIf="filterbox">
                    </div>
                    <div class="row" *ngIf="filterbox">
                        <div class="col-lg-6">
                            <div class="input-group input-group-info input-group-sm p-1">
                                <input type="text" #table_search name="table_search" class="form-control form-control-sm" placeholder="nome cliente o descrizione..." [(ngModel)]="this.filter_search.value" (keyup.enter)="updateList()">
                                <div class="input-group-append ">
                                    <button type="submit" class="btn btn-default text-primary"  title="avvia ricerca" (click)="updateList()"><i class="fas fa-search"></i></button>
                                    <button class="btn btn-default text-danger" *ngIf="filter_search.value!=''"  title="annulla ricerca" (click)="filter_search.value='';updateList();"><span id="searchclear" class="fas fa-times"></span></button>
                                    <button class="btn btn-default" title="Ricerca avanzata" data-toggle="collapse" data-target="#advancedSearchPanel"  aria-expanded="false" aria-controls="advancedSearchPanel" ><span id="searchclear" class="fas fa-sliders-h"></span></button>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-lg-3 py-1">
                            <select class="form-control form-control-sm p-1" [(ngModel)]="this.filter_phase.value" (change)="getItems()">
                                <option value="0">Tutte le fasi</option>
                                <option value="1">Preventivato</option>
                                <option value="2">In corso</option>
                                <option value="5">Sospeso</option>
                                <option value="3">Concluso</option>
                                <option value="4">Annullato</option>
                            </select>
                        </div>
                        <div class="col-6 col-lg-3">
                            <div class="pr-1">
                                <app-windowlistbuttons 
                                [model]="this"  
                                [table]="'project'" 
                                [funs]="[]"
                                ></app-windowlistbuttons>
                            </div>
                            <!-- <button *ngIf="filter_status.value == '1'" (click)="trash()" [disabled]="form.value.id.length == 0" class="btn btn-danger btn-xs float-right mx-1 mt-1"><i class="far fa-trash-alt"></i></button>
                            <button *ngIf="filter_status.value == '2'" (click)="delete()" [disabled]="form.value.id.length == 0" class="btn btn-danger btn-xs float-right "><i class="fas fa-trash"></i></button>
                            <button *ngIf="filter_status.value == '2'" (click)="undo()" [disabled]="form.value.id.length == 0" class="btn btn-secondary btn-xs float-right "><i class="fas fa-undo"></i></button>
                            <button  (click)="export()" class="btn btn-secondary btn-xs float-right "><i class="fas fa-file-export"></i></button>
                            <button (click)="openDetail(null)"  class="btn btn-success btn-xs float-right "><i class="fas fa-plus"></i><span class="d-none d-sm-inline-block">&ensp;</span></button> -->
                        </div>
                    </div>
                     <div class="row">
                        <div class="col-12">
                            <div  class="small-box card m-1 p-1 collapse" id="advancedSearchPanel">
                                <div class="row">
                                    <div class="col-10 col-lg-10">
                                        <app-advancedsearch [id_field]="'p.id'" [table]="'project'" [filters]="advancedFilter"></app-advancedsearch>
                                    </div>
                                    <div class="col-2 col-lg-2 pl-1">
                                        <button title="Filtra" class="btn btn-default border btn-sm h-100 float-right" (click)="updateList()">
                                            <i class="fa fa-filter"></i><span class="ml-1 d-none d-lg-inline">Applica</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!list || list.length==0" class="m-5 text-center text-secondary">
                        <i class="icon fas fa-info-circle mr-2"></i><i>{{messageStatus}}</i>
    
                    </div>
                   
                    <form *ngIf="list && list.length>0" [formGroup]="form">
                        <table class="table table-nowrap  table-sm table-head-fixed table-striped m-0 text-sm">
                            <thead>
                                <th width="20px">
                                    <input #checkboxselectall type="checkbox" title="Seleziona tutti"
                                    (change)="onChangeAll($event.target.checked);calculateSelected(false,false)" />
                                </th>
                                <th class="d-none d-lg-table-cell"></th>
                                <th class="d-none d-lg-table-cell">
                                    Date
                                    <button type="button" class="btn btn-tool" (click)="switchOrdering('p.date')">
                                        <i class="fas fa-sort {{classOrdering('p.date')}}"></i>
                                    </button>
                                </th>
                                <th class="">
                                    Cod./Titolo/Desc.
                                    <button type="button" class="btn btn-tool" (click)="switchOrdering('p.code')">
                                        <i class="fas fa-sort {{classOrdering('p.code')}}"></i>
                                    </button>
                                </th>
                                <th class="d-none d-lg-table-cell" *ngIf="id_address==0 && !showAmount">
                                    Anagrafica
                                </th>
                                <th class="d-none d-xl-table-cell text-center">
                                    Fase
                                </th>
                                <th class="text-right">
                                    Importo
                                    <button type="button" class="btn btn-tool" (click)="switchOrdering('p.amount')">
                                        <i class="fas fa-sort {{classOrdering('p.amount')}}"></i>
                                    </button>
                                </th>
                                <ng-container *ngIf="showAmount">
                                    <th class="d-none d-xl-table-cell text-right">Costi</th>
                                    <th class="d-none d-xl-table-cell text-right">Ricavi</th>
                                    <th class="d-none d-lg-table-cell text-right">Rimanenza</th>
                                    <th class="d-none d-xl-table-cell text-right">Margine</th>
                                    <th class="d-none d-xl-table-cell text-right"></th>
                                </ng-container>
                                <ng-container *ngIf="!showAmount">
                                    <th *ngFor="let t of tableColumns" class="d-none d-xl-table-cell text-center" style="max-width: 6rem;">
                                        {{t.label}}
                                    </th>                                                          
                                    <th class="d-none d-lg-table-cell text-center">
                                        Operatore
                                    </th>
                                </ng-container>     
                                <th class="text-right">
                                    <button title="Mostra campi personalizzati" type="button" class="btn btn-xs btn-default border float-right d-none d-lg-block" (click)="editTableHeader()"><i class="fa fa-edit"></i></button>
                                    <button title="Mostra dati economici" [class.bg-primary]="showAmount==true"  type="button" class="btn btn-xs btn-default border float-right d-none d-lg-block" (click)="showAmount==true?showAmount=false:showAmount=true;updateList()"><i class="fa fa-dollar-sign"></i></button>
                                </th>
                            </thead>
                            <tbody>

                                <!-- elemento ripetuto -->
                                <tr *ngFor="let record of list"
                                    [class.bg-futureline]=""
                                    [class.bg-yellowline]="record.phase==5"
                                    [class.bg-greenline]="record.phase==2"
                                    [class.bg-redline]="">
                                    <td>
                                        <input type="checkbox" #checkrecord id_record="{{record.id}}" title="ID: {{record.id}}"
                                        (change)="onChange(record.id, $event.target.checked);calculateSelected(record, $event.target.checked)" [checked]="checkedAll"
                                        />
                                    </td>
                                    <td class="d-none d-lg-table-cell">
                                        <i *ngIf="record.note!=undefined && record.note!=''" [title]="record.note" class="fa fa-exclamation-circle help" ></i>
                                    </td>             
                                    <td class="d-none d-lg-table-cell">
                                        <span title="data inizio" class="">
                                            {{record.date | date:'dd/MM/yyyy'}}
                                        </span>
                                        <span *ngIf="record.date_end && record.date_end!='0000-00-00'" title="data fine" class="text-gray">
                                            <br>&#10551; {{record.date_end | date:'dd/MM/yyyy'}}
                                        </span>
                                    </td>                                   
                                    <td class="pointer" (click)="openDetail(record)" title="Modifica / Vedi" style="max-width: 12rem;">
                                        <ng-container *ngIf="record.code">
                                            <small class="text-purple">{{record.code}}</small><br>
                                        </ng-container>                                        
                                        <b>{{record.name}}</b><br>                                        
                                        <small><i class="d-inline-block overflow-hidden w-100 text-gray" style="max-height:3.5rem">{{record.description}}</i></small>
                                        <!-- <ng-container *ngIf="record.note!=undefined && record.note!=''">
                                            <br><small class="d-inline-block overflow-hidden w-100 help" style="max-height:1.7rem;" title="{{record.note}}">
                                                <i class="fas fa-thumbtack text-info mr-2"></i>{{record.note}}</small>
                                        </ng-container> -->
                                    </td>
                                    <td class="d-none d-lg-table-cell" *ngIf="id_address==0 && !showAmount" style="max-width: 6rem;" >
                                        <i class="fas fa-user text-gray mr-1"></i>
                                        <ng-container *ngIf="record.addressItem">
                                            {{ record.addressItem.name }}<br/>
                                            <small class="text-gray">{{ record.addressItem.address }}</small>,&ensp;
                                            <small class="text-gray">{{ record.addressItem.city }}</small>
                                        </ng-container>
                                    </td>
                                    <td class="d-none d-xl-table-cell text-center">
                                        <span class="badge border" *ngIf="record.phase==1">preventivato</span>
                                        <span class="badge border border-success text-success" *ngIf="record.phase==2">in corso</span>
                                        <span class="badge border bg-primary" *ngIf="record.phase==3">concluso</span>
                                        <span class="badge border bg-danger" *ngIf="record.phase==4">annullato</span>
                                        <span class="badge border border-warning text-warning" *ngIf="record.phase==5">sospeso</span>
                                    </td>
                                     <td class="text-right">
                                        {{record.amount | currency:"&euro;"}}
                                    </td>
                                    <ng-container *ngIf="showAmount">
                                        <td class="d-none d-xl-table-cell text-right">
                                            {{record.cost | currency:"&euro;"}}
                                        </td>
                                        <td class="d-none d-xl-table-cell text-right">
                                            {{record.paid | currency:"&euro;"}}
                                        </td>
                                        <td class="d-none d-lg-table-cell text-right">
                                            <span class="text-danger help" *ngIf="record.phase!=4 && (record.amount - record.paid > 0.01)" title="Differenza tra importo e ricavi">
                                                {{record.paid - record.amount | currency:"&euro;"}}
                                            </span>
                                            <span class="text-danger help" *ngIf="record.phase==4 && (record.cost - record.paid > 0.05)" title="Differenza tra costi e ricavi">
                                                {{record.paid - record.cost | currency:"&euro;"}}
                                            </span>
                                        </td>
                                        <td class="d-none d-xl-table-cell text-right">
                                            <span class="help" *ngIf="record.phase==2 || record.phase==3" title="Differenza tra costi e ricavi" 
                                                [class.text-success]="record.paid - record.cost > 0.05"
                                                [class.text-danger]="record.paid - record.cost < -0.05" >
                                                {{record.paid - record.cost | currency:"&euro;"}}
                                            </span>
                                        </td>
                                        <td class="d-none d-xl-table-cell text-right">
                                            <span class="help" *ngIf="record.phase==3" title="Margine/Importo" 
                                                [class.text-success]="record.paid - record.cost > 0.05"
                                                [class.text-danger]="record.paid - record.cost < -0.05" >
                                                ({{(record.paid - record.cost) / record.amount * 100 | number:'0.0'}}%)
                                            </span>                                        
                                        </td>                                        
                                    </ng-container>
                                    <ng-container *ngIf="!showAmount">
                                        <td class="d-none d-xl-table-cell text-center" *ngFor="let t of tableColumns" style="max-width: 6rem;">
                                            {{t.getValue(record)}}
                                        </td>
                                         <td>                                
                                            <div *ngIf="record.username" class="rounded-circle d-flex align-items-center justify-content-center bg-purple mx-auto text-uppercase help" style="height:2rem; width:2rem" title="{{record.username}} ">{{record.username[0]}}</div>
                                        </td>
                                    </ng-container>
                                    <td>
                                        <button type="button" *ngIf="mode!='modal'"  (click)="openDetail(record)" routerLinkActive="active"  title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right mr-1">
                                            <i class="fas fa-pencil-alt"></i><span class="d-none d-sm-inline-block">&ensp;</span></button>
                                        <button type="button" *ngIf="mode!='modal'" (click)="duplicate(record)" title="Duplica" class="btn btn-info btn-xs float-right ">
                                            <i class="far fa-clone"></i></button>                                  
                                        <button type="button"  *ngIf="mode=='modal'" class="btn btn-secondary btn-xs float-right" (click)="selectRecord(record);">
                                            <span class="d-none d-sm-inline-block m-1">Seleziona</span><i class="fas fa-chevron-right"></i>
                                        </button>
                                    </td>
                                </tr>
                                <!-- FINE elemento ripetuto -->

                            </tbody>
                            <tfoot class="bg-white">
                                <tr>
                                    <td colspan="2"><b>TOTALE</b></td>
                                    <td class="d-none d-lg-table-cell"></td>
                                    <td class="d-none d-lg-table-cell"></td>
                                    <td class="d-none d-lg-table-cell" *ngIf="id_address==0 && !showAmount"></td>
                                    <td class="d-none d-xl-table-cell"></td>
                                    <td class="text-right">
                                        <b>{{total | currency:'EUR':true }}</b>
                                    </td>
                                    <ng-container *ngIf="showAmount">
                                        <td class="d-none d-xl-table-cell text-right">
                                            <b>{{total_cost | currency:'EUR':true }}</b>
                                        </td>
                                        <td class="d-none d-xl-table-cell text-right">
                                            <b>{{total_paid | currency:'EUR':true }}</b>
                                        </td>
                                        <td class="d-none d-lg-table-cell"></td>
                                        <td colspan="2" class="d-none d-xl-table-cell"></td>
                                    </ng-container>
                                    <ng-container *ngIf="!showAmount">
                                        <td class="d-none d-xl-table-cell text-center" *ngFor="let t of tableColumns; let i=index">                                                
                                            <b>{{total_columns[i]}}</b>
                                        </td>
                                        <td></td>
                                    </ng-container>                                    
                                    <td></td>
                                </tr>
                                <tr class="text-primary" *ngIf="num_selected>1">
                                    <td colspan="2">
                                        <i><b>SELEZIONATI</b> ({{num_selected}} elementi)</i>
                                    </td>
                                    <td class="d-none d-lg-table-cell"></td>
                                    <td class="d-none d-lg-table-cell"></td>
                                    <td class="d-none d-lg-table-cell" *ngIf="id_address==0 && !showAmount"></td>
                                    <td class="d-none d-xl-table-cell"></td>
                                    <td class="text-right">
                                        <b>{{total_amount_selected | currency:'EUR':true }}</b>
                                    </td>
                                    <ng-container *ngIf="showAmount">
                                        <td class="d-none d-xl-table-cell text-right">
                                            <b>{{total_paid_selected | currency:'EUR':true }}</b>
                                        </td>
                                        <td class="d-none d-xl-table-cell text-right">
                                            <b>{{total_cost_selected | currency:'EUR':true }}</b>
                                        </td>
                                        <td class="d-none d-lg-table-cell"></td>
                                        <td colspan="2" class="d-none d-xl-table-cell"></td>
                                    </ng-container>
                                    <ng-container *ngIf="!showAmount">
                                        <td class="d-none d-xl-table-cell text-center" *ngFor="let t of tableColumns"></td>
                                        <td></td>
                                    </ng-container>                                    
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </form>
                </div>
                <div class="card-footer clearfix py-1">
                    <app-pagination [model]="this" ></app-pagination>
                </div>
            </div>
        </div>
    </div>
</app-windowlist>